export const howToUseModal = {
    slide1: {
        title: 'About the Cluster & Value Chain',
        text01:
            'The analysis results of the technology group (cluster) included in the selected theme are displayed using a bubble chart for each value chain to which the company belongs.\nSelect a cluster bubble to see more details at the bottom of the screen.'
    },
    slide2: {
        title: 'About the four domains',
        text01:
            'You can understand the current technological trend by checking which domain of the chart the cluster bubble belongs to.',
        listTitle01: 'Domain 1: Domain for exploring technological seeds',
        listText01:
            'Although not as attractive both technically and as a market, these technology clusters with growing scores and Market Expectation have the potential of becoming the next-generation trend, and requires close attention in the research department. Analyze the growth rate to discover technologies that will lead to the future.',
        listTitle02: 'Domain 2: Domain with a high possibility of technological development',
        listText02:
            'It is a technological domain where technological development are receiving significant investments despite being immature, such as startups. The domain should be pursued for future-oriented in-house research and development, investments in external technology-holding companies, and strengthening of alliances.',
        listTitle03: 'Domain 3: Domain that is at the forefront of technological trends',
        listText03:
            'It is a technological domain that is nucleus for shaping new market landscapes,while technological development is progressing, and investment is also being garnered. R&D will inevitably have a higher priority. If there is no in-house technology in this domain, it becomes a potential target for short-term acquisition through M&A.',
        listTitle04: 'Domain 4: Domain that is technologically maturing',
        listText04:
            'Technologies that have matured, become cash cows, or are forgotten, such as basic technologies in existing markets. This is a region where changes in the external environment may create new markets, and the effective use of in-house technologies should be considered.',
        link: 'View detailed terminology'
    },
    slide3: {
        title: 'About the Value Chain',
        text01: 'The data is displayed using the following mechanism.',
        listTitle01: 'Analysis method',
        listText01:
            'Analysis processing (factor analysis and clustering) is performed for each value chain to which each company belongs, and themes are broken down into clusters. By mapping the clusters with Market Expectation x patent score, we can identify overall technology trends.',
        link: 'View detailed terminology'
    },
    slide4: {
        title: 'Please use Help and guidance if you experience any problems',
        listTitle01: 'You can access the support page from Help',
        listTitle02: 'You can check this guidance at any time',
        listText02: `Please click "How to read the chart" on the right side of the bubble chart for more information.`,
        link: {
            before: 'Please use the ',
            middle: ' and ',
            after: ' provided.'
        }
    }
}
